module.exports = __webpack_public_path__ + "img/plus.d985f8a4.svg";